import React, { ReactElement } from 'react'
import classNames from 'classnames'
import Tooltip from '../tooltip/Tooltip'

import { ReactComponent as homeIcon } from '../../../assets/header/home.svg'

import { ReactComponent as assessmentsIcon } from '../../../assets/sidebar/assessments.svg'
import { ReactComponent as brandingIcon } from '../../../assets/sidebar/branding.svg'
import { ReactComponent as emailIcon } from '../../../assets/sidebar/email.svg'
import { ReactComponent as eventsIcon } from '../../../assets/sidebar/events.svg'
import { ReactComponent as settingsIcon } from '../../../assets/sidebar/settings.svg'
import { ReactComponent as simulationsIcon } from '../../../assets/sidebar/simulations.svg'
import { ReactComponent as scheduleIcon } from '../../../assets/sidebar/schedule.svg'
import { ReactComponent as filterIcon } from '../../../assets/sidebar/filter.svg'
import { ReactComponent as starIcon } from '../../../assets/sidebar/star.svg'
import { ReactComponent as usersIcon } from '../../../assets/sidebar/users.svg'
import { ReactComponent as clientsIcon } from '../../../assets/sidebar/clients.svg'
import { ReactComponent as diskIcon } from '../../../assets/sidebar/disk.svg'
import { ReactComponent as gameControllerIcon } from '../../../assets/sidebar/game.svg'
import { ReactComponent as auditLogIcon } from '../../../assets/sidebar/audit.svg'

import { ReactComponent as pencilIcon } from '../../../assets/common/pencil.svg'
import { ReactComponent as banIcon } from '../../../assets/common/ban.svg'
import { ReactComponent as trashIcon } from '../../../assets/common/trash.svg'
import { ReactComponent as copyIcon } from '../../../assets/common/copy.svg'
import { ReactComponent as clipboard } from '../../../assets/common/clipboard.svg'
import { ReactComponent as cloneIcon } from '../../../assets/common/clone.svg'
import { ReactComponent as closeIcon } from '../../../assets/common/close.svg'
import { ReactComponent as editIcon } from '../../../assets/common/edit.svg'
import { ReactComponent as keyIcon } from '../../../assets/common/key.svg'
import { ReactComponent as tickIcon } from '../../../assets/common/tick.svg'
import { ReactComponent as lockIcon } from '../../../assets/common/lock.svg'
import { ReactComponent as lockOpenIcon } from '../../../assets/common/lockOpen.svg'
import { ReactComponent as lockClosedIcon } from '../../../assets/common/lockClosed.svg'
import { ReactComponent as unlockIcon } from '../../../assets/common/unlocked.svg'
import { ReactComponent as ideaIcon } from '../../../assets/common/idea.svg'
import { ReactComponent as mailIcon } from '../../../assets/common/mail.svg'
import { ReactComponent as uploadIcon } from '../../../assets/common/upload.svg'
import { ReactComponent as searchIcon } from '../../../assets/common/search.svg'
import { ReactComponent as addUserIcon } from '../../../assets/common/addUser.svg'
import { ReactComponent as addEventIcon } from '../../../assets/common/addEvent.svg'
import { ReactComponent as exportIcon } from '../../../assets/common/export.svg'
import { ReactComponent as importIcon } from '../../../assets/common/import.svg'
import { ReactComponent as plusIcon } from '../../../assets/common/plus.svg'
import { ReactComponent as arrowIcon } from '../../../assets/common/arrow.svg'
import { ReactComponent as infoIcon } from '../../../assets/common/info.svg'
import { ReactComponent as draggableIcon } from '../../../assets/common/draggable.svg'
import { ReactComponent as group } from '../../../assets/common/group.svg'
import { ReactComponent as preview } from '../../../assets/common/preview.svg'
import { ReactComponent as refresh } from '../../../assets/common/refresh.svg'
import { ReactComponent as calculator } from '../../../assets/common/calculator.svg'
import { ReactComponent as help } from '../../../assets/common/help.svg'
import { ReactComponent as sculpting } from '../../../assets/common/sculpting.svg'
import { ReactComponent as treasure } from '../../../assets/common/treasure.svg'
import { ReactComponent as eye } from '../../../assets/common/eye.svg'
import { ReactComponent as hidden } from '../../../assets/common/hidden.svg'

import { ReactComponent as playIcon } from '../../../assets/gamecontroller/play.svg'
import { ReactComponent as disconnect } from '../../../assets/gamecontroller/link.svg'
import { ReactComponent as pauseIcon } from '../../../assets/gamecontroller/pause.svg'
import { ReactComponent as statusIcon } from '../../../assets/gamecontroller/status.svg'
import { ReactComponent as giftIcon } from '../../../assets/gamecontroller/gift.svg'
import { ReactComponent as timerIcon } from '../../../assets/gamecontroller/clock.svg'
import { ReactComponent as roundClock } from '../../../assets/gamecontroller/roundclock.svg'
import { ReactComponent as roundPlusIcon } from '../../../assets/gamecontroller/plus.svg'
import { ReactComponent as roundMinusIcon } from '../../../assets/gamecontroller/minus.svg'
import { ReactComponent as roundStopIcon } from '../../../assets/gamecontroller/stop.svg'
import { ReactComponent as squareIcon } from '../../../assets/gamecontroller/square.svg'
import { ReactComponent as roundPlayIcon } from '../../../assets/gamecontroller/roundPlay.svg'
import { ReactComponent as circleIcon } from '../../../assets/gamecontroller/circle.svg'

import { ReactComponent as communityTrust } from '../../../assets/summary/communityTrust.svg'
import { ReactComponent as creditRating } from '../../../assets/summary/creditRating.svg'
import { ReactComponent as customerComplaints } from '../../../assets/summary/customerComplaints.svg'
import { ReactComponent as customerSatisfaction } from '../../../assets/summary/customerSatisfaction.svg'
import { ReactComponent as employeeEngagement } from '../../../assets/summary/employeeEngagement.svg'
import { ReactComponent as loanImpairment } from '../../../assets/summary/loanImpairment.svg'
import { ReactComponent as regulatorSanctions } from '../../../assets/summary/regulatorSanctions.svg'
import { ReactComponent as returnOnEquity } from '../../../assets/summary/returnOnEquity.svg'
import { ReactComponent as risk } from '../../../assets/summary/risk.svg'
import { ReactComponent as shareHolderReturn } from '../../../assets/summary/shareHolderReturn.svg'

import { ReactComponent as npatGrowth } from '../../../assets/financial/npatGrowth.svg'
import { ReactComponent as nim } from '../../../assets/financial/nim.svg'
import { ReactComponent as costOfFunds } from '../../../assets/financial/costOfFunds.svg'
import { ReactComponent as costToIncome } from '../../../assets/financial/costToIncome.svg'
import { ReactComponent as capitalRatio } from '../../../assets/financial/capitalRatio.svg'
import { ReactComponent as remediationAndFines } from '../../../assets/financial/remediationAndFines.svg'

import { ReactComponent as homeLoans } from '../../../assets/business/homeLoans.svg'
import { ReactComponent as businessLoans } from '../../../assets/business/businessLoans.svg'
import { ReactComponent as creditCards } from '../../../assets/business/creditCards.svg'
import { ReactComponent as deposits } from '../../../assets/business/deposits.svg'
import { ReactComponent as wealthManagement } from '../../../assets/business/wealthManagement.svg'
import { ReactComponent as institutionalBanking } from '../../../assets/business/institutionalBanking.svg'
import { ReactComponent as offshoreBank } from '../../../assets/business/offshoreBank.svg'

import { ReactComponent as goldMedal } from '../../../assets/results/goldMedal.svg'
import { ReactComponent as silverMedal } from '../../../assets/results/silverMedal.svg'
import { ReactComponent as bronzeMedal } from '../../../assets/results/bronzeMedal.svg'

import { ReactComponent as citizens} from '../../../assets/results/citizens.svg'
import { ReactComponent as dollars} from '../../../assets/results/dollars.svg'
import { ReactComponent as hammer} from '../../../assets/results/hammer.svg'
import { ReactComponent as scales} from '../../../assets/results/scales.svg'
import { ReactComponent as sayno} from '../../../assets/results/say-no.svg'

import { ReactComponent as newsBear} from '../../../assets/results/newsBear.svg'
import { ReactComponent as newsBull} from '../../../assets/results/newsBull.svg'
import { ReactComponent as newsEmerging} from '../../../assets/results/newsEmerging.svg'
import { ReactComponent as newsGlobe} from '../../../assets/results/newsGlobe.svg'
import { ReactComponent as newsOutlook} from '../../../assets/results/newsOutlook.svg'
import { ReactComponent as bank } from '../../../assets/results/bank.svg'
import { ReactComponent as emptyPockets } from '../../../assets/results/emptyPockets.svg'
import { ReactComponent as slide } from '../../../assets/results/slide.svg'

import { ReactComponent as report } from '../../../assets/common/report.svg'


import './Icon.scss'
import Theme from '../../../styles/_theme.module.scss'
import { ThemeColours, ThemeSpacing } from '../../../types/theme'

const mapTypeToIcon = {
  assessments: assessmentsIcon,
  branding: brandingIcon,
  email: emailIcon,
  events: eventsIcon,
  settings: settingsIcon,
  simulations: simulationsIcon,
  schedule: scheduleIcon,
  pencil: pencilIcon,
  ban: banIcon,
  trash: trashIcon,
  copy: copyIcon,
  clipboard,
  clone: cloneIcon,
  close: closeIcon,
  edit: editIcon,
  key: keyIcon,
  tick: tickIcon,
  lock: lockIcon,
  lockOpen: lockOpenIcon,
  lockClosed: lockClosedIcon,
  unlock: unlockIcon,
  idea: ideaIcon,
  mail: mailIcon,
  upload: uploadIcon,
  home: homeIcon,
  search: searchIcon,
  filter: filterIcon,
  star: starIcon,
  users: usersIcon,
  clients: clientsIcon,
  disk: diskIcon,
  addUser: addUserIcon,
  addEvent: addEventIcon,
  export: exportIcon,
  import: importIcon,
  plus: plusIcon,
  gameController: gameControllerIcon,
  play: playIcon,
  disconnect,
  pause: pauseIcon,
  status: statusIcon,
  gift: giftIcon,
  timer: timerIcon,
  roundClock,
  arrow: arrowIcon,
  roundPlus: roundPlusIcon,
  roundMinus: roundMinusIcon,
  roundStop: roundStopIcon,
  square: squareIcon,
  roundPlay: roundPlayIcon,
  circle: circleIcon,
  info: infoIcon,
  draggable: draggableIcon,
  audit: auditLogIcon,
  communityTrust,
  creditRating,
  customerComplaints,
  customerSatisfaction,
  employeeEngagement,
  loanImpairment,
  regulatorSanctions,
  returnOnEquity,
  risk,
  shareHolderReturn,
  npatGrowth,
  nim,
  costOfFunds,
  costToIncome,
  capitalRatio,
  remediationAndFines,
  preview,
  refresh,
  calculator,
  sculpting,
  treasure,
  eye,
  hidden,
  group,
  homeLoans,
  businessLoans,
  creditCards,
  deposits,
  wealthManagement,
  institutionalBanking,
  offshoreBank,
  help,
  goldMedal,
  silverMedal,
  bronzeMedal,
  citizens,
  dollars,
  hammer,
  scales,
  sayno,
  newsBear,
  newsBull,
  newsEmerging,
  newsGlobe,
  newsOutlook,
  bank,
  emptyPockets,
  slide,
  report
}

export type IconType = keyof typeof mapTypeToIcon

export interface Props extends React.SVGProps<SVGSVGElement> {
  type: IconType
  tip?: {
    id?: string
    content: string | ReactElement
  }
  active?: boolean
  className?: string
  /**
   * @deprecated Use `colour` instead.
   */
  fill?: string
  hidden?: boolean
  size?: ThemeSpacing
  colour?: ThemeColours
  noMargin?: boolean
}

function Icon(props: Props) {
  const { type, tip, size, colour, active, className, fill, hidden, noMargin, ...rest } = props
  const SVGIcon = mapTypeToIcon[type]
  const sizeClass = size ? `size-${size}` : null
  const colourClass = colour ? `colour-${colour}` : null

  let toolTipProps = {}

  if (tip?.id) {
    // When a id is provided, a new ReactTooltip instance will be created
    // Use it wisely and it may have performance impact when there are many instances in a page
    toolTipProps = {
      'data-tip': '',
      'data-for': tip.id
    }
  } else {
    toolTipProps = {
      'data-tip': tip?.content
    }
  }

  return (
    <>
      <SVGIcon
        className={classNames('icon', { active, hidden, 'no-margin': noMargin }, sizeClass, colourClass, [className])}
        fill={fill || Theme.primaryGrey}
        {...toolTipProps}
        {...rest}
      />
      {!!tip?.id && <Tooltip
        id={tip.id}
      >
        {tip.content}
      </Tooltip>}
    </>
  )
}

export default Icon
